/**
 * @deprecated Use auto-generated services instead
 */
export async function fetcher(
	url: string,
	type: "GET" | "POST" | "PUT" | "DELETE" = "GET",
	data?: BodyInit,
	appkey: string = "",
	token: string = ""
) {
	const aramcolife = window.aramcolife;

	if (aramcolife && aramcolife.appkey && aramcolife.token) {
		token = aramcolife.token;
		appkey = aramcolife.appkey;
	}

	const headers: HeadersInit = {
		"Accept": "application/json",
		"Content-Type": "application/json"
	};

	if (appkey) {
		headers.AppKey = appkey;
	}

	if (token) {
		headers.TokenAuthorization = `Bearer ${token}`;
	}

	const fetchConfig: RequestInit = {
		method: type,
		headers
	};

	if (data) {
		fetchConfig.body = JSON.stringify(data);
	}

	try {
		const response = await fetch(url, fetchConfig);
		if (response.status === 200) {
			return await response.json();
		}

		if (response.ok) {
			return;
		}

		console.warn(`Looks like there was a problem. Status Code ${response.status}`);
	} catch (error) {
		console.warn("Looks like there was a problem.", error);
	}
}
